import { useMediaQuery } from "@mui/material";
import { EditableDataGrid } from "../../../../builderPackage/components/editableDataGrid/editableDataGrid";
var CourierDetailsGrid = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'courierDetails' : _a;
    var currValue = value[name];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var columns = [{
            type: 'string',
            field: 'Sr. no',
            headerName: 'Sr. no',
            width: 100,
            headerAlign: 'center',
            disableColumnMenu: true
        }, {
            field: 'Courier name',
            headerName: 'Courier name',
            width: 150,
            headerAlign: 'center',
            disableColumnMenu: true,
            editable: true
        }, {
            field: 'Dealer ID',
            headerName: 'Dealer ID',
            width: 120,
            headerAlign: 'center',
            editable: true
        }, {
            type: 'date',
            field: 'Booking date',
            headerName: 'Booking date',
            width: 170,
            headerAlign: 'center',
            disableColumnMenu: true
        }, {
            type: 'number',
            field: 'Docket number',
            headerName: 'Docket number',
            width: 180,
            headerAlign: 'center',
            disableColumnMenu: true,
            editable: true
        }, {
            field: 'No. of sample',
            headerName: 'No. of sample',
            minWidth: 150,
            headerAlign: 'center',
            disableColumnMenu: true,
            editable: true
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Courier details",
        isCollapsible: false,
        columns: columns,
        dataGridProps: {
            hideFooter: true
        },
        rows: currValue || [],
        onChange: onChange
    });
};
export default CourierDetailsGrid;
